jQuery(function($) {
  window.lazyLoader = new LazyLoading();
  lazyLoader.onLoaded(function(elem) {
    // console.log(elem);
  });

  var scrollEvents = new ScrollEvents();
  var fontsOnlyLoadOnce = false;

  function onFontsLoaded() {
    if (fontsOnlyLoadOnce) return;
    fontsOnlyLoadOnce = true;
    $("body").addClass("fonts_loaded");
    setTimeout(function() {
      $("body").addClass("load_step_1");
    }, 100);
    setTimeout(function() {
      $("body").addClass("load_step_2");
    }, 100);
    setTimeout(function() {
      $("body").addClass("load_step_3");
    }, 100);

    $(window).trigger("fontsLoaded");
  }

  if (window.fontsLoaded) {
    onFontsLoaded();
  } else {
    $("#fonts").load(function() {
      onFontsLoaded();
    });
  }

  $(window).on('load', function() {
    var anchors = new Anchors();
    onFontsLoaded();
    $(document).ready(function() {
      $(".modaal_trigger").on("click", function(e){
        e.stopPropagation();
      })
      $(".modaal_trigger").modaal({
        hide_close: true,
        overlay_opacity: 0.6,
        background_scroll: false
      });
    })
    var close = $(".close");

    close.focus();
    close.click(function() {
      $(".modaal_trigger").modaal("close");
      return false;
    });
  });

  $("body").addClass("ready");

  // Attempt to fix Paige home hero video issue
  setTimeout(function() {
    $(window).trigger("resize");
    setTimeout(function() {
      $(window).trigger("resize");
    }, 1000);
  }, 1000);

  // Add a class for when panel animation is done
  setTimeout(function() {
    $("body").addClass("panels_loaded");
    $(window).trigger("panelsLoaded");
  }, 1500);
});